import { Injectable } from '@angular/core';

import { LoginResponse } from '../../../models/kartinatv-responses/client/login.response';
import DictionaryStr from '../../../models/dictionary';
import AccountInfoResponse from '../../../models/kartinatv-responses/client/account-info.response';
import { KartinaTvHttpService } from './base.http.service';
import { LogoutResponse } from '../../../models/kartinatv-responses/client/logout.response';
import { DeviceService } from '../../../services/device-service';

@Injectable()
export default class ClientHttpService {
    constructor(
        private readonly kartinaRequester: KartinaTvHttpService,
        private readonly deviceService: DeviceService) {
    }

    public async loginAsync(login: string, password: string): Promise<LoginResponse> {
        const params = new DictionaryStr<string>();
        params['login'] = login;
        params['pass'] = password;
        params['softid'] = 'canada_WEBUI';
        params['cli_serial'] = this.deviceService.getMac();
        return await this.kartinaRequester.getAsync<LoginResponse>('v3/login', params);
    }

    public async logoutAsync(): Promise<LogoutResponse> {
        // todo: this is workaround because of exc on the server side
        try {
            await this.kartinaRequester.postJsonAsync<LogoutResponse>('v3/logout', null);
        } catch (err) {
        }
        return new LogoutResponse();
    }

    public async accountInfoAsync(showSettings: boolean): Promise<AccountInfoResponse> {
        const params = new DictionaryStr<string>();
        params['settings'] = showSettings ? '1' : '0';
        return await this.kartinaRequester.getAsync<AccountInfoResponse>('account', params);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/kartinatv/client.http.service.ts